export default "__VITE_ASSET__CR1_wa9C__"